// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__w_3WF","detailsBorder":"styles_detailsBorder__3CfK5"};